import { COLORS, FONTS } from '../../../../constants';

const styles = theme => {
  const minSm = theme.breakpoints.up('sm');
  const minMd = theme.breakpoints.up('md');
  const maxXs = theme.breakpoints.down('xs');

  return {
    cardHeaderRoot: {
      backgroundColor: COLORS.GREY_DARK,
    },
    cardHeaderTitle: {
      color: COLORS.WHITE,
      textAlign: 'center',
      fontSize: '1.25rem',
      fontWeight: 600,
    },
    formRow: {
      width: '100%',
      [minSm]: {
        display: 'flex',
        justifyContent: 'space-between',
      },
      '&:first-child': {
        marginTop: -20,
        [minMd]: {
          marginTop: -30,
        },
      },
    },
    formGroup: {
      width: '100%',
      marginTop: 20,
      [minMd]: {
        marginTop: 30,
      },
    },
    halfFormGroup: {
      width: '100%',
      [minSm]: {
        width: '48%',
      },
    },
    textCenter: {
      textAlign: 'center',
    },
    profilePhoto: {
      height: '200px',
      width: '200px',
      objectFit: 'cover',
      borderRadius: '10px',
    },
    photoUpload: {
      height: '200px',
      width: '200px',
      backgroundColor: '#f1f1f1',
      borderRadius: '10px',
      margin: '8px 10px 0 0',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      cursor: 'pointer',
      flexDirection: 'column',
    },
    remove: {
      position: 'absolute',
      top: '5%',
      right: '8%',
      border: '1px solid white',
      borderRadius: '50%',
      color: 'white',
      display: 'flex',
      width: ' 20px',
      height: ' 20px',
      alignItems: 'center',
      justifyContent: 'center',
      cursor: 'pointer',
      boxSizing: 'border-box',
      backgroundColor: 'rgb(10 10 10 / 62%)',
      borderStyle: 'solid',
    },
    imageContainer: {
      position: 'relative',
    },
    topImageFormGroup: {
      marginTop: '30px',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      [maxXs]: {
        display: 'block',
      },
    },
    topImageSingle: {
      display: 'flex',
      alignItems: 'center',
      '& p': {
        marginLeft: 5,
      },
    },
    galleryImages: {
      display: 'flex',
      flexWrap: 'wrap',
      '& img': {
        margin: '8px 10px 0 0',
      },
    },
    textLabel: {
      fontFamily: FONTS.PRIMARY,
      textTransform: 'uppercase',
      color: COLORS.GREY_DARKER,
      fontSize: '0.75rem',
      fontWeight: 600,
    },
  };
};

export default styles;
